// src/pages/UnderConstruction.jsx
import React from "react";
import { useParams } from "react-router-dom";

export default function UnderConstruction({ title }) {
  const { moduleId, subId } = useParams();

  const heading = title || "Próximamente";

  const description = title
    ? `Estamos preparando este espacio dentro del ecosistema ZEDRO Academy.`
    : `Estamos preparando el submódulo ${subId || "—"} del módulo ${moduleId || "—"}.`;

  return (
    <main
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1.5rem",
        background: "var(--page-bg)",
        fontFamily: "Questrial, sans-serif",
      }}
    >
      <section
        style={{
          width: "100%",
          maxWidth: 620,
          textAlign: "center",
          padding: "3rem 2rem",
          borderRadius: 28,
          background: "#ffffff",
          border: "1px solid rgba(15, 47, 70, 0.08)",
          boxShadow: "0 18px 45px rgba(15, 47, 70, 0.06)",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            marginBottom: "1.1rem",
            padding: "0.42rem 0.8rem",
            borderRadius: 999,
            background: "rgba(204, 163, 82, 0.12)",
            color: "#9b7527",
            fontSize: "0.72rem",
            fontWeight: 800,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          }}
        >
          Próximamente
        </div>

        <h1
          style={{
            margin: 0,
            color: "#0f2f46",
            fontSize: "clamp(1.7rem, 3vw, 2.35rem)",
            fontWeight: 400,
            letterSpacing: "-0.045em",
            lineHeight: 1.05,
          }}
        >
          {heading}
        </h1>

        <p
          style={{
            margin: "1rem auto 0",
            maxWidth: 460,
            color: "rgba(15, 47, 70, 0.68)",
            fontSize: "1rem",
            lineHeight: 1.65,
          }}
        >
          {description}
        </p>
      </section>
    </main>
  );
}